import React from "react";
import Skeleton from "react-loading-skeleton";
import { AuditLog } from "../types";
import { useGetGroupUserInfoQuery } from "../../../../services/userAPI";
import { FaEye } from "react-icons/fa";
import useGetLanguage from "../../../../utils/useGetLanguage";
import { LanguageText } from "../../../../dictionary/GroupsText";
interface AuditLogRowProps {
  log: AuditLog;
  groupId: string;
  ownerID?: string;
  onShowDetails: (log: AuditLog) => void;
}

const AuditLogRow: React.FC<AuditLogRowProps> = ({
  log,
  groupId,
  ownerID,
  onShowDetails,
}) => {
  const Language: LanguageText = useGetLanguage({
    fileName: "GroupsText",
  });

  const {
    data: userInfo,
    isLoading: userLoading,
    error: userError,
  } = useGetGroupUserInfoQuery({
    groupID: groupId,
    userID: log.user_id,
  });

  return (
    <tr className="hover:bg-gray-50">
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center">
          <div className="flex-shrink-0 h-10 w-10">
            <div className="h-10 w-10 rounded-full bg-gray-300 flex items-center justify-center">
              <span className="text-sm font-medium text-gray-700">
                {userLoading ? (
                  <Skeleton height={16} width={16} circle />
                ) : (
                  userInfo?.username?.charAt(0)?.toUpperCase() || "U"
                )}
              </span>
            </div>
          </div>
          <div className="ml-4">
            <div className="text-sm font-medium text-gray-900">
              {userLoading ? (
                <Skeleton height={16} width={100} />
              ) : (
                userInfo?.username || "Unknown User"
              )}
            </div>
            <div className="text-sm text-gray-500">
              {userLoading ? (
                <Skeleton height={14} width={60} />
              ) : userInfo?.id === ownerID ? (
                Language?.groupAuditLogs?.owner
              ) : (
                Language?.groupAuditLogs?.member
              )}
            </div>
          </div>
        </div>
      </td>

      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
        {userLoading ? (
          <Skeleton height={16} width={120} />
        ) : (
          userInfo?.email || "Unknown Email"
        )}
      </td>

      <td className="px-6 py-4 whitespace-nowrap">
        <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800">
          {log.action}
        </span>
      </td>

      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
        {log.resource_type}
      </td>

      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
        {new Date(log.timestamp).toLocaleString()}
      </td>

      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
        <button
          onClick={() => onShowDetails(log)}
          className="text-blue-600 hover:text-blue-900 flex items-center gap-1"
        >
          <FaEye size={15} />
        </button>
      </td>
    </tr>
  );
};

export default AuditLogRow;
